import { createContext, ReactNode, useState, useContext } from 'react';

import { api } from '../services/api';

type DevedorContextProps = {
  children: ReactNode;
};

export type Devedor = {
  cpf: string;
  nome: string;
  cep: string;
  endereco: string;
  bairro: string;
  cidade: string;
  uf: string;
  complemento?: string;
  numero_endereco: number;
  email: string;
  empresa: string;
};

export type Telefone = {
  id?: string;
  telefone: string;
  whatsapp?: number;
  tipo: string;
  classificacao: string;
  isComercial?: boolean;
  isWhatsapp?: boolean;
};

export type DevedorCadastro = {
  cgc_cpf: string;
  nome: string;
  cep: string;
  logradouro: string;
  bairro: string;
  cidade: string;
  uf: string;
  complemento?: string;
  numero_endereco: number;
  email: string;
  empresa: string;
};

type DevedorContextData = {
  devedor: Devedor;
  cpf: string;
  showData: boolean;
  telefoneFixo: Telefone;
  telefoneMovel: Telefone;
  whatsapp: Telefone;
  telefoneFixoComercial: Telefone;
  telefoneMovelComercial: Telefone;
  faturas_parc: Fatura_Parc[];
  getDevedor: (CGC_CPF: string) => Promise<number>;
  mostrarData: (show: boolean) => void;
  setDevedor: React.Dispatch<React.SetStateAction<Devedor>>;
};

interface Parcela {
  valorparc: number;
  valorPago?: number;
  vencimento: string;
  pagamento: string;
  documento: number;
  nroparc: number;
}
export type IFaturas = {
  documento: number;
  tipodoc: number;
  n_inicial?: number;
  n_final?: number;
  qtdeparc: number;
  data1parc: string;
  valorparc: number;
  valorfatura?: number;
};

export interface Fatura_Parc {
  fatura: IFaturas;
  parcelas: Parcela[];
}

const DevedorContext = createContext({} as DevedorContextData);

export function DevedorProvider({ children }: DevedorContextProps) {
  const [devedor, setDevedor] = useState<Devedor>({} as Devedor);
  const [cpf, setCPF] = useState<string>('');
  const [showData, setShowData] = useState(false);

  const [telefoneFixo, setTelefoneFixo] = useState<Telefone>({} as Telefone);
  const [telefoneMovel, setTelefoneMovel] = useState<Telefone>({} as Telefone);
  const [whatsapp, setWhatsapp] = useState<Telefone>({} as Telefone);
  const [telefoneFixoComercial, setTelefoneFixoComercial] = useState<Telefone>(
    {} as Telefone,
  );
  const [telefoneMovelComercial, setTelefoneMovelComercial] =
    useState<Telefone>({} as Telefone);
  const [faturas_parc, setFaturasParc] = useState<Fatura_Parc[]>([]);

  async function getDevedor(CGC_CPF: string): Promise<number> {
    try {
      const { data, status } = await api.get(`devedor/listar`, {
        params: {
          cpf: CGC_CPF,
        },
      });
      setDevedor(data.devedor);
      setCPF(CGC_CPF);
      setFaturasParc(data.faturas_parc);

      if (data.telefones) {
        // eslint-disable-next-line array-callback-return
        data.telefones?.map((telefone: Telefone) => {
          if (telefone.tipo === 'fixo') {
            setTelefoneFixo(telefone);
          } else if (telefone.tipo === 'movel') {
            setTelefoneMovel(telefone);
          } else if (telefone.tipo === 'whatsapp') {
            setWhatsapp(telefone);
          } else if (telefone.tipo === 'fixo_comercial') {
            setTelefoneFixoComercial(telefone);
          } else {
            setTelefoneMovelComercial(telefone);
          }
        });
      }

      return status;
    } catch (err) {
      return 500;
    }
  }

  function mostrarData(show: boolean) {
    setShowData(show);
  }

  return (
    <DevedorContext.Provider
      value={{
        devedor,
        cpf,
        getDevedor,
        telefoneFixo,
        telefoneMovel,
        whatsapp,
        telefoneFixoComercial,
        telefoneMovelComercial,
        faturas_parc,
        mostrarData,
        showData,
        setDevedor,
      }}
    >
      {children}
    </DevedorContext.Provider>
  );
}

export const useDevedor = () => useContext(DevedorContext);
